// extracted by mini-css-extract-plugin
module.exports = {"component":"text-description_component__a17VO","headline":"text-description_headline__56mUC","tags":"text-description_tags__h0bWA"};